export const canvas = document.getElementById("canvas");
export const ctx = canvas.getContext("2d");

const pathStraight = new Image();
pathStraight.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_150/v1518732697/path_zaebmd.png';

export default class Path {
  constructor (pathX, pathY) {
    // instantiate each path with null unless there is a path on each then write
    // conditional logic based on if there is a path adjacent so dog can exit
    this.pathX = pathX;
    this.pathY = pathY;
    this.pathWidth = 100;
    this.pathHeight = 100;

  }

  drawPath() {
    ctx.drawImage(pathStraight, this.pathX, this.pathY, this.pathWidth, this.pathHeight);
    // ctx.drawImage(pathStraight, 300, 520, 100, 100);
    // ctx.drawImage(pathStraight, 400, 520, 100, 100);
    // ctx.drawImage(pathStraight, 500, 520, 100, 100);
    // ctx.drawImage(pathStraight, 500, 420, 100, 100);
    // ctx.drawImage(pathStraight, 500, 320, 100, 100);
    // ctx.drawImage(pathStraight, 400, 320, 100, 100);
    // ctx.drawImage(pathStraight, 300, 320, 100, 100);
    // ctx.drawImage(pathStraight, 200, 320, 100, 100);
    // ctx.drawImage(pathStraight, 100, 320, 100, 100);
    // ctx.drawImage(pathStraight, 100, 220, 100, 100);
    // ctx.drawImage(pathStraight, 100, 120, 100, 100);
    // ctx.drawImage(pathStraight, 200, 120, 100, 100);
    // ctx.drawImage(pathStraight, 300, 120, 100, 100);
    // ctx.drawImage(pathStraight, 300, 20, 100, 100);
  }
}



// WEBPACK FOOTER //
// ./lib/path.js